export const enumCheckInStatus = {
    future: 0,
    waiting: 1,
    completed: 2,
    notChecked: 3
};